import React, { FunctionComponent } from "react";

interface ListLoadFailureProps {
  /** What could not be loaded, as the sentence names it ("role list", "location list"). */
  noun: string;
  /** What the learner can do meanwhile, when there is something ("You can still type yours."). */
  hint?: string;
  onRetry: () => void;
}

/**
 * Says, in as many words, that the list did not arrive.
 *
 * It exists because the alternative reads as an answer: an empty closed dropdown looks like "there is
 * no such role", and the field's own empty text ("ask your coordinator to have it added") would send
 * a learner to a person who cannot help when nothing was ever fetched. Role cannot be answered at all
 * until this is resolved, so the message carries the retry rather than leaving the learner to reload
 * the page and lose what they have filled in.
 *
 * `onMouseDown` is prevented because this also renders inside the Select's open dropdown, where the
 * default would blur the field and close the dropdown out from under the click.
 */
const ListLoadFailure: FunctionComponent<ListLoadFailureProps> = ({ noun, hint, onRetry }) => (
  <span className="text-sm text-error-1" onMouseDown={event => event.preventDefault()}>
    We could not load the {noun}.{hint ? ` ${hint}` : ""}{" "}
    <button type="button" className="cursor-pointer border-none bg-transparent p-0 font-medium text-primary-6 underline" onClick={onRetry}>
      Try again
    </button>
  </span>
);

export default ListLoadFailure;
